import React, {useEffect} from "react";
import CheckBox from '../../Fields/CheckBox';

const CMDatabases = (props) =>{
    const {formJson, setFormJson, gqdbAccess} = props
    
    useEffect(()=> {
        if(formJson){
            let change = false;

            if(formJson.searchInfo.nucdbs == null){
                formJson.searchInfo.nucdbs = ["CASPAT_NUC_MS"];
                change = true
            }
            
            if(formJson.searchInfo.protdbs == null){
                formJson.searchInfo.protdbs = [];
                change = true
            }
            

            if(change){
                setFormJson({...formJson})
            }
        }
    }, [formJson])

    const toggleDb = (db, checked) =>{

        if(formJson.searchInfo.qdb_seq_type === "protein"){
            if(db === "cas"){
                db = "CASPAT_PRT_MS";
            }
            if(db === "gq"){
                db = "GQPAT_PRT_MS";
            }
            if(db === "casnp"){
                db = "CASNP_PRT_MS";
            }

            if(checked){
                if(!formJson.searchInfo.protdbs.includes(db)){
                    formJson.searchInfo.protdbs.push(db);
                }
            }else{
                formJson.searchInfo.protdbs = formJson.searchInfo.protdbs.filter(d => d !== db);
            }
        }else{

            if(db === "cas"){
                db = "CASPAT_NUC_MS";
            }
            if(db === "gq"){
                db = "GQPAT_NUC_MS";
            }
            if(db === "casnp"){
                db = "CASNP_NUC_MS";
            }

            if(checked){
                if(!formJson.searchInfo.nucdbs.includes(db)){
                    formJson.searchInfo.nucdbs.push(db);
                }
            }else{
                formJson.searchInfo.nucdbs = formJson.searchInfo.nucdbs.filter(d => d !== db);
            }
        }
        
        setFormJson({...formJson})
    }

    return (
    <div style={{paddingBottom: "10px"}}>
        {formJson.searchInfo.protdbs != null && formJson.searchInfo.nucdbs != null &&
        <div>
        <p className="subHeading w-50 mb-10">Databases</p>
            <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
               
                <div style={{display: "flex", alignItems: "center"}} >
                    <CheckBox
                        id="cas_cm_db"
                        color="primary"
                        checked = {formJson.searchInfo.protdbs.includes("CASPAT_PRT_MS") || formJson.searchInfo.nucdbs.includes("CASPAT_NUC_MS")}
                        onChange={(e)=>{toggleDb("cas", e.target.checked)}}
                        //disabled={formJson.layout.isRedo === true}
                    />
                    <label htmlFor="cas_cm_db" className={"cursorPointer cmdbHeading"}>CAS Biosequences - Chemical Modification from Patents (CM)</label>  
                </div>   
                <div style={{display: "flex", alignItems: "center"}} >
                    <CheckBox
                        id="casnp_cm_db"
                        color="primary"
                        checked = {formJson.searchInfo.protdbs.includes("CASNP_PRT_MS") || formJson.searchInfo.nucdbs.includes("CASNP_NUC_MS")}
                        onChange={(e)=>{toggleDb("casnp", e.target.checked)}}
                        //disabled={formJson.layout.isRedo === true}
                    />
                    <label htmlFor="casnp_cm_db" className={"cursorPointer cmdbHeading"}>CAS Biosequences - Chemical Modification from Journals and Proceedings (CM)</label>  
                </div>    
                <div style={{display: "flex", alignItems: "center"}} >
                    <CheckBox
                        id="gq_cm_db"
                        color="primary"
                        checked = {formJson.searchInfo.protdbs.includes("GQPAT_PRT_MS") || formJson.searchInfo.nucdbs.includes("GQPAT_NUC_MS")}
                        onChange={(e)=>{toggleDb("gq", e.target.checked)}}
                        disabled={!(gqdbAccess)} // formJson.layout.isRedo === true ||
                    />
                    <label htmlFor="gq_cm_db" className={"cursorPointer cmdbHeading"} style={!(gqdbAccess) ? {color:"#777"} : {}}>GQPAT - Chemical Modification (CM)</label>          
                </div>
            </div>
        </div>
    }
    </div>
    );
}

export default CMDatabases;